import arakkanImg from "../images/afro-solar/on-grid-solar/arkarn-rooftop.webp";
import elMariaImg from "../images/afro-solar/on-grid-solar/el-manya.webp";
import mazarImg from "../images/afro-solar/on-grid-solar/mazar-mail.webp";
import orionImg from "../images/afro-solar/on-grid-solar/orion-factory.webp";
import shaheElImg from "../images/afro-solar/on-grid-solar/shah-el.webp";
import wadiImg from "../images/afro-solar/on-grid-solar/wadi-natrun.webp";

const projects = [
  {
    img: arakkanImg,
    name: "Arkan Rooftop",
  },
  {
    img: mazarImg,
    name: "Mazar Mall​",
  },
  {
    img: orionImg,
    name: "Orion Factory​",
  },
  {
    img: wadiImg,
    name: "Wadi Natrun​",
  },
  {
    img: elMariaImg,
    name: "El-Minya​",
  },
  {
    img: shaheElImg,
    name: "Sahl El - Haseesh​",
  },
];

const OnGridProjectExamples = () => {
  return (
    <div className="pb-5 pt-11" id="industry-benchmarks">
      <h1 className="fs-56 lh-64 text-center gilroy-bold pb-5">
        Industry Benchmarks
      </h1>
      <div className="container-fluid">
        <div className="me-13 ms-13">
          <div className="row align-items-center">
            {/* <div className="col-12 col-md-6 p-4">
              <h2 className="fs-56 gilroy-bold text-white">
                ON-GRID SOLAR PPA{" "}
                <span className="d-block">​Project examples:</span>
              </h2>
            </div> */}
            <div className="col-12 bg-white p-4 rounded">
              <div className="row">
                {projects.map((project) => (
                  <div
                    key={project.name}
                    className="col-12 col-sm-6 col-md-6 pb-5"
                  >
                    <img
                      src={project.img}
                      alt={project.name}
                      className="img-fluid rounded w-100"
                    />
                    <h3 className="fs-18 gilroy-bold mt-4">{project.name}</h3>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnGridProjectExamples;
